import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { KenoWallet } from './KenoWallet';
import { KenoFairnessPanel } from './KenoFairnessPanel';
import { GameInfo } from './GameInfo';
import { Wallet } from 'lucide-react';

const titles = { wallet: 'Wallet', fairness: 'Fairness', info: 'Game Info' };
export const KenoDialogs = ({ view, setView, game }) => {
  useEffect(() => { if (view === 'wallet' && game.demo) setView(null); }, [view, game.demo, setView]);
  return <Dialog open={!!view && view !== 'stats' && (view !== 'wallet' || !game.demo)} onOpenChange={(open) => { if (!open) setView(null); }}>
  <DialogContent className={`keno-dialog${view === 'wallet' ? ' finance-dialog' : view === 'fairness' ? ' fairness-dialog' : ''}`} data-testid="keno-dialog">
    <DialogHeader><DialogTitle data-testid="keno-dialog-title">{view === 'wallet' && <Wallet size={23} aria-hidden="true" />}{titles[view]}</DialogTitle><DialogDescription className="sr-only">{titles[view]}</DialogDescription></DialogHeader>
    {view === 'fairness' && <KenoFairnessPanel game={game} />}
    {view === 'wallet' && !game.demo && <KenoWallet game={game} onClose={() => setView(null)} />}
    {view === 'info' && <GameInfo game={game} />}
  </DialogContent>
</Dialog>;
};